import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractService } from '../services/abstract.service';
import { AssetModel } from './asset.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AssetService extends AbstractService<AssetModel> {
  constructor(http: HttpClient) {
    super(http, '/assetItems', AssetModel);
  }

  ammount(): Observable<any> {
    return this.http.get<any>(this.path + '/ammount');
  }

  ammountByClasses(): Observable<any[]> {
    return this.http.get<any[]>(this.path + '/ammountByClasses');
  }
}
